const _allMensagens = [
	{
		val: 'GERAL',
		text: 'Geral',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`À disposição. Obrigada!`,

			`Olá! Como posso ajudar?`,

			`Algo mais em que eu possa ajudar?`,

			`Por gentileza, aguarde um momento enquanto verifico as informações solicitadas.`,

			`Por gentileza, aguarde um momento enquanto verifico a agenda disponível.`,
		]
	}

];

const getMensagens = () => _allMensagens;

module.exports = {
	getMensagens
}
